import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Ptag, OverlayLoader } from "components/core";
import backarrow from "assets/images/arrowBack.png";
import creditlogo from "assets/images/green_up_arrow.png";
import debitlogo from "assets/images/green_down_arrow.png";
import { formatAmountWithDecimal, formatDecimalToCSV } from "utlis/utils";
import {
  LongLine,
  ImgHeader,
  BackButton,
  HomeWrapper,
  MessageWrapper,
  Text2,
  TopHeader,
  Table,
  EmployeeHeader,
  MsgTag,
  OuterHeader,
} from "components/CdBalance/style";
import BaseBreadcrumbs from "components/core/BaseBreadcrumbs";

const Transactions = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [ledgerTable, setLedgerTable] = useState([]);
  const location = useLocation();
  const state = location.state.transactionData;

  const handleChange = () => {
    navigate("/view_cd_balance");
  };

  const getData = async () => {
    setLoading(true);
    setLedgerTable(state);
    setLoading(false);
  };
  useEffect(() => {
    getData();
  }, []);

  const getImg = (transaction_status) => {
    const logo = transaction_status === "Credit" ? creditlogo : debitlogo;
    return (
      <img
        style={{
          height: "10px",
          marginRight: "5px",
          textAlign: "top",
          paddingTop: "0",
        }}
        src={logo}
        height="20px"
        width="17px"
      />
    );
  };

  const getTransactionSign = (transaction_status) => {
    return transaction_status === "Credit" ? "+" : "-";
  };

  const crumbs = useMemo(() => {
    return [
      {
        name: "Cash Deposit Account",
        path: "/v1/cash-deposit"
      },
      {
        name: "Transaction History",
        active: true
      }
    ]
  }, [])

  const renderLedgerTable = () => {
    return (
      <>
      <BaseBreadcrumbs breadcrumbs={crumbs} />
        <Table>
          <tbody>
            {ledgerTable &&
              ledgerTable.map((individualRow, index) => (
                <tr style={{ borderBottom: "#b01313", height: 48 }}>
                  <td>
                    <ImgHeader>
                      {getImg(individualRow.transaction_type)}
                    </ImgHeader>
                  </td>
                  <td>
                    <OuterHeader>
                      <EmployeeHeader>
                        <Ptag
                          paddingLeft="10px"
                          fontSize="16px"
                          fontWeight="600"
                          minWidth="80%"
                        >
                          {individualRow.action_show}
                        </Ptag>
                        <Ptag
                          paddingLeft="10px"
                          fontSize="12px"
                          fontWeight="400"
                          marginTop="2px"
                        >
                          {individualRow.transaction_date_show}
                        </Ptag>
                      </EmployeeHeader>
                    </OuterHeader>
                  </td>
                  <td>
                    <TopHeader>
                      <Ptag
                        paddingLeft="10px"
                        fontWeight="600"
                        fontSize="16px"
                        maxLength="80%"
                      >
                        {getTransactionSign(individualRow.transaction_type)} ₹
                        {formatDecimalToCSV(individualRow.transacted_balance)}
                      </Ptag>
                      <Ptag paddingLeft="10px" fontSize="12px" marginTop="2px" fontWeight="400">
                        Balance ₹
                        {formatDecimalToCSV(individualRow.updated_balance)}
                      </Ptag>
                    </TopHeader>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </>
    );
  };

  const renderNoHistoryMessage = () => {
    return (
      <MsgTag>
        <MessageWrapper>
          <Text2>
            Currently, we do not have any transaction history regarding your CD
            account.
          </Text2>
          <Text2>
            If you have made any recent transactions, please reach out to your
            Account Manager at Vital to get the same updated here.
          </Text2>
        </MessageWrapper>
      </MsgTag>
    );
  };

  const cdLedger = () => {
    return (
      <section>
        {/* <BackButton onClick={handleChange}>
          <img
            style={{ marginRight: "10px" }}
            src={backarrow}
            height="20px"
            width="17px"
          />
          <Ptag fontSize="15px" textAlign="center">
            Back
          </Ptag>
        </BackButton> */}
        {!(typeof ledgerTable == "string")
          ? renderLedgerTable()
          : renderNoHistoryMessage()}
      </section>
    );
  };

  if (loading) <OverlayLoader />;

  return <>{cdLedger()}</>;
};

export default Transactions;
